import { getFeature } from 'Cloud/Application/FeaturesEs6';

// CLOUDWEB-19324: фича включает поддержку csv на открытие на редактирование
export const csvMaxEditableSize: number | undefined = getFeature('csv-max-editable-size');
